import { render, staticRenderFns } from "./driverStatistics.vue?vue&type=template&id=c98bfb2c&scoped=true&"
import script from "./driverStatistics.vue?vue&type=script&lang=js&"
export * from "./driverStatistics.vue?vue&type=script&lang=js&"
import style0 from "./driverStatistics.vue?vue&type=style&index=0&id=c98bfb2c&scoped=true&lang=css&"
import style1 from "./driverStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98bfb2c",
  null
  
)

export default component.exports